import React from 'react';
import { Tooltip } from 'react-tippy';

const SocialBanner = props => (
  <div className="row">
    <div className="properties-condition">
      <ul className="social-networks">
        {props.artist.facebook && (
          <li>
            <Tooltip
              title="Facebook"
              position="bottom"
              trigger="mouseenter"
              followCursior
            >
              <a target="_blank" rel="noopener noreferrer" href={props.artist.facebook}>
                <i className="fa fa-facebook-official" aria-hidden="true" />
              </a>
            </Tooltip>
          </li>
        )}
        {props.artist.twitter && (
          <li>
            <Tooltip
              title="Twitter"
              position="bottom"
              trigger="mouseenter"
              followCursior
            >
              <a target="_blank" rel="noopener noreferrer" href={props.artist.twitter}>
                <i className="fa fa-twitter-square" aria-hidden="true" />
              </a>
            </Tooltip>
          </li>
        )}
        {props.artist.linkedin && (
          <li>
            <Tooltip
              title="Linkedin"
              position="bottom"
              trigger="mouseenter"
              followCursior
            >
              <a target="_blank" rel="noopener noreferrer" href={props.artist.linkedin}>
                <i className="fa fa-linkedin-square" aria-hidden="true" />
              </a>
            </Tooltip>
          </li>
        )}
        {props.artist.youtube && (
          <li>
            <Tooltip
              title="Youtube"
              position="bottom"
              trigger="mouseenter"
              followCursior
            >
              <a target="_blank" rel="noopener noreferrer" href={props.artist.youtube}>
                <i className="fa fa-youtube-square" aria-hidden="true" />
              </a>
            </Tooltip>
          </li>
        )}
        {props.artist.soundcloud && (
          <li>
            <Tooltip
              title="Soundcloud"
              position="bottom"
              trigger="mouseenter"
              followCursior
            >
              <a target="_blank" rel="noopener noreferrer" href={props.artist.soundcloud}>
                <i className="fa fa-soundcloud" aria-hidden="true" />
              </a>
            </Tooltip>
          </li>
        )}
        {props.artist.website && (
          <li>
            <Tooltip
              title="Sitio Web"
              position="bottom"
              trigger="mouseenter"
              followCursior
            >
              <a target="_blank" rel="noopener noreferrer" href={props.artist.website}>
                <i className="fa fa-globe" aria-hidden="true" />
              </a>
            </Tooltip>
          </li>
        )}
      </ul>
    </div>
  </div>
);

export default SocialBanner;



// WEBPACK FOOTER //
// ./src/containers/General/ArtistPage/SocialBanner.js